import { Route } from 'vue-router';


export default class RouteUtils {
  public static getParam(route: Route, paramName: string): string {
    return (route.params || {})[paramName] || (route.meta || {}).pageCode;
  }
}
